module.exports = __webpack_public_path__ + "20_cikm.pdf?fde3aeb6e6d655b5d25f7dfd52941064";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperData/20_cikm.pdf
// module id = 151
// module chunks = 0